import * as getters from './getters'
import mutations from './mutations'
import * as actions from './actions'

const state = {
  policyList: [],
  policyType: '',
  policiesLoaded: false,
}

export default {
  state,
  getters,
  mutations,
  actions,
}
